var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBad(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 29,
    viewBox: "0 0 24 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.679 26.8417C15.63 26.9269 14.7344 28.3674 13.117 28.3674C11.5174 28.3674 11.406 26.7308 11.406 26.1853C11.406 24.7022 11.9273 22.3368 13.4734 18.4329C13.6962 17.8746 13.665 17.589 13.6383 17.5293C13.6294 17.5293 13.5002 17.4569 13.117 17.4569L4.56211 17.4569C2.67736 17.4569 1.14016 15.9908 1.14016 14.1837L1.14016 13.5657C0.663408 13.0799 -0.000484958 12.1763 -0.000484848 10.9106C-0.000484767 9.98145 0.360422 9.2484 0.739153 8.72844C0.360424 8.21275 -0.000484547 7.47544 -0.000484466 6.54634C-0.000484356 5.28481 0.663408 4.37701 1.14016 3.89115L1.14016 3.27317C1.14016 1.47037 2.67736 3.86206e-06 4.56211 4.02683e-06L17.6796 5.17359e-06C21.1372 5.47587e-06 23.9531 2.69355 23.9531 6.00081L23.9531 13.0927C23.9531 14.5076 23.5031 15.8629 22.6521 17.0136L15.679 26.8417Z",
    fill: "#E36667"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBad);
export default __webpack_public_path__ + "static/media/bad.0d05f47d.svg";
export { ForwardRef as ReactComponent };